export const HISTORY_ACTIONS = {
  LOG_HISTORY: 'HISTORY/LOG',
  UNDO: 'HISTORY/UNDO',
  REDO: 'HISTORY/REDO',
  SET_PRESENT: 'HISTORY/SET_PRESENT',
  PROPAGATE_PRESENT: 'HISTORY/PROPAGATE_PRESENT',
  CLEAR: 'HISTORY/CLEAR',
};
